import { useEffect, useState } from "react";
import { Card, Col, Row, Form, Button } from "antd";
import { useForm } from "react-hook-form";
import { InputField } from "../../../../../atoms/FormFields";
import { useLocation, useNavigate } from "react-router-dom";
import FullPageLayout from "../../../../../templates/FullPageLayout";
import { createEquipment } from "../../../ducks/services";
import { AxiosError } from "axios";
import SuccessMessage from "../../../../../atoms/Toasts/SuccessMessage";
import ErrorMessage from "../../../../../atoms/Toasts/ErrorMessage";
import { CreateMaterialType } from "../../../ducks/types";
import { useAppDispatch, useAppSelector } from "../../../../../config/hooks";
import { getCompanyFieldsById } from "../../../../CompanySettings/TagsCategories/ducks/actions";
import { SelectFieldTags } from "../../../../../atoms/FormFields/SelectFieldTags";
import { NeedHelp, UploadIcon } from "../../../../../atoms/CustomIcons";

interface CategoryType {
  label: string;
  value: string;
  color: string;
}

export default function AddEquipment() {
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const url = useLocation();
  const dispatch = useAppDispatch();
  const companyId = url?.pathname.split("/")[2];
  const tagItems = useAppSelector((state) => state?.tags?.tagData);
  const [categoryDropDown, setCategoryDropDown] = useState<CategoryType[]>([]);

  useEffect(() => {
    if (tagItems?.data && tagItems?.data?.length > 0) {
      const dummyArray: CategoryType[] = [];
      tagItems?.data?.map((item: { name: string; id: string; color: string }) =>
        dummyArray.push({
          label: item?.name,
          value: item?.id,
          color: item?.color,
        })
      );
      setCategoryDropDown(dummyArray);
    } else {
      setCategoryDropDown([]);
    }
  }, [tagItems]);

  const {
    control,
    handleSubmit,
    getValues,
    trigger,
    reset,
    formState: { errors },
  } = useForm<CreateMaterialType>();

  const onSubmit = (val: CreateMaterialType) => {
    setLoading(true);

    const payload = {
      name: val?.name?.trim(),
      category_ids:
        val?.category_ids && val?.category_ids?.length > 0
          ? val?.category_ids
          : [],
      company_id: companyId,
    };

    createEquipment(payload)
      .then(() => {
        setLoading(false);
        SuccessMessage("Equipment added");
        navigate(`/inventory/equipment/${companyId}`);
      })
      .catch((e: unknown) => {
        if (e instanceof AxiosError) {
          setLoading(false);
          ErrorMessage(
            e?.response?.data?.error?.message ?? "Something went wrong"
          );
        } else {
          setLoading(false);
          ErrorMessage("Something went wrong");
        }
      });
  };

  const saveAddMore = async () => {
    const allValues = getValues();
    const isValid = await trigger();

    if (isValid) {
      setLoading(true);

      const payload = {
        name: allValues?.name?.trim(),
        category_ids:
          allValues?.category_ids && allValues?.category_ids?.length > 0
            ? allValues?.category_ids
            : [],
        company_id: companyId,
      };

      createEquipment(payload)
        .then(() => {
          setLoading(false);
          SuccessMessage("Equipment added.");
          reset();
        })
        .catch((e: unknown) => {
          setLoading(false);
          if (e instanceof AxiosError) {
            ErrorMessage(
              e?.response?.data?.error?.message ?? "Something went wrong"
            );
          } else {
            ErrorMessage("Something went wrong");
          }
        });
    }
  };

  useEffect(() => {
    if (companyId) {
      const payload = {
        company_id: companyId,
        module: "EQUIPMENT",
      };

      dispatch(getCompanyFieldsById(payload));
    }
  }, [dispatch, companyId]);

  return (
    <FullPageLayout loading={loading}>
      <Button className="btn-sm fixedTopBtn">
        <NeedHelp /> Need help?
      </Button>
      <Form
        layout="vertical"
        onFinish={handleSubmit(onSubmit)}
        onKeyDown={(e) => {
          if (e.key === "Enter") e.preventDefault();
        }}
      >
        <Col style={{ width: "672px", paddingBottom: 90 }}>
          <div
            className="title"
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <h2> Add equipment </h2>
            <Button
              htmlType="button"
              className="outlined-btn btn-sm"
              type="primary"
              onClick={() => navigate(`/upload-equipment/${companyId}`)}
            >
              <UploadIcon /> Bulk upload
            </Button>
          </div>
          <Card>
            <Row gutter={20}>
              <Col span={24} className="createForm">
                <h4> Equipment details </h4>
                <InputField
                  fieldName="name"
                  label="Equipment name"
                  control={control}
                  defaultValue=""
                  iProps={{
                    placeholder: "Enter equipment name",
                  }}
                  isRequired
                  rules={{
                    required: "Equipment name is required.",
                  }}
                  validate={errors.name && "error"}
                  validMessage={errors.name && errors.name.message}
                />

                <SelectFieldTags
                  fieldName="category_ids"
                  label="Categories"
                  control={control}
                  selectOption={categoryDropDown}
                  className="bottom_0"
                  iProps={{
                    placeholder: "Select categories",
                    mode: "multiple",
                  }}
                  tooltipTitle="Categories are used for combining materials into groups."
                />
              </Col>
            </Row>
          </Card>
        </Col>
        <div className="fixed_btm_card">
          <Card>
            <div className="centered">
              <Button
                htmlType="button"
                className="outlined-btn"
                onClick={() => navigate(`/inventory/equipment/${companyId}`)}
              >
                Cancel
              </Button>
              <div style={{ display: "flex", gap: "16px" }}>
                <Button
                  htmlType="button"
                  className="outlined-btn"
                  type="primary"
                  onClick={saveAddMore}
                >
                  Save & add more
                </Button>
                <Button
                  htmlType="submit"
                  type="primary"
                  className="mint-btn"
                  // disabled={true}
                >
                  Save equipment
                </Button>
              </div>
            </div>
          </Card>
        </div>
      </Form>
    </FullPageLayout>
  );
}
